<template>
  <div class="my-drawer-wrapper">
    <el-form :model="setting">
      <el-form-item label="背景类型选择" required>
        <el-radio-group v-model="setting.actStr">
          <el-radio style="padding: 10px 0" label="dot">点阵背景</el-radio>
          <el-radio style="padding: 10px 0" label="bgcolor">纯色背景</el-radio>
          <el-radio style="padding: 10px 0" label="gbgcolor">渐变背景</el-radio>
          <el-radio style="padding: 10px 0" label="localImg">本地图片</el-radio>
          <el-radio style="padding: 10px 0" label="netImg">网络图片</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="点阵背景" v-show="setting.actStr === 'dot'" required>
        <el-checkbox v-model="setting.dot">{{
          setting.dot ? "已开启" : "已关闭"
        }}</el-checkbox>
      </el-form-item>
      <el-form-item label="纯色背景" v-show="setting.actStr === 'bgcolor'" required>
        <el-color-picker
          popper-class="my-color-picker"
          v-model="setting.bgcolor"
          size="medium"
          show-alpha
        ></el-color-picker>
      </el-form-item>
      <el-form-item label="渐变背景" v-show="setting.actStr === 'gbgcolor'" required>
        <div>
          <el-radio v-model="setting.gbgcolor.type" label="linear-gradient"
            >线性渐变</el-radio
          >
          <el-radio v-model="setting.gbgcolor.type" label="radial-gradient"
            >径向渐变</el-radio
          >
        </div>
        <div>
          <el-color-picker
            v-for="(item, i) in setting.gbgcolor.colors"
            :key="item + i"
            popper-class="my-color-picker"
            v-model="setting.gbgcolor.colors[i]"
            size="medium"
            show-alpha
          ></el-color-picker>
        </div>
        <div>
          <el-link
            v-show="setting.gbgcolor.colors.length <= 3"
            @click="addColor"
            style="padding: 0 10px"
            type="primary"
            >添加颜色</el-link
          >
          <el-link
            v-show="setting.gbgcolor.colors.length >= 3"
            @click="delColor"
            style="padding: 0 10px"
            type="danger"
            >删除颜色</el-link
          >
        </div>
      </el-form-item>
      <el-form-item label="本地图片" v-show="setting.actStr === 'localImg'" required>
        <el-upload
          action="false"
          :auto-upload="false"
          :limit="1"
          :accept="allowed"
          list-type="picture-card"
          :on-change="handleUpload"
          :on-exceed="handleExceed"
          :on-preview="previewLocalImg"
          :on-remove="removeLocalImg"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-link type="warning">注意：电脑上传的本地图片，浏览器不支持存储！(如果存储在浏览器，请选择网络图片)</el-link>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="previewImg" alt="无法显示">
        </el-dialog>
      </el-form-item>
      <el-form-item label="网络图片" v-show="setting.actStr === 'netImg'" required>
        <el-input placeholder="请输入完整的网络图片地址" v-model="setting.netImg"></el-input>
      </el-form-item>
    </el-form>
    <div class="my-drawer__footer">
      <el-button @click="cancelDrawer">取 消</el-button>
      <el-button type="primary" @click="takeEffect">立即生效</el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Message } from "element-ui";
Vue.component(Message.name,Message);
export default {
  name: "back-setting",
  props: ["set"],
  data() {
    return {
      setting: {
        actStr: "dot",
        dot: true,
        bgcolor: null,
        gbgcolor: {
          type: "linear-gradient",
          colors: ["#409EFF", "#409EFF"],
        },
        localImg: null,
        netImg: null,
      },
      previewImg: null,
      allowed: ".jpg,.jpeg,.png",
      dialogVisible: false
    };
  },
  mounted() {
    this.setting = JSON.parse(JSON.stringify(this.set));
  },
  methods: {
    handleUpload(file) {
      this.setting.localImg = file.url;
      this.previewImg = file.url;
    },
    removeLocalImg() {
      this.previewImg = null;
      this.setting.localImg = null;
    },
    handleExceed() {
      Message({
        message: "请先删除上一张图片后，再重新上传！",
        type: "warning",
      });
    },
    previewLocalImg() {
      this.dialogVisible = true;
    },
    cancelDrawer() {
      this.$emit("cancel");
    },
    takeEffect() {
      if (this.setting.actStr !== "dot" && !this.setting[this.setting.actStr]) {
        Message({
          message: "请在选项下赋值后再重试！",
          type: "error",
        });
        return;
      }
      this.$emit("effect",this.setting);
    },
    addColor() {
      if (this.setting.gbgcolor.colors.length >= 4) {
        return;
      }
      this.setting.gbgcolor.colors.push("#409EFF");
    },
    delColor() {
      const len = this.setting.gbgcolor.colors.length;
      if (len <= 2) {
        return;
      }
      this.setting.gbgcolor.colors.splice(len - 1, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.my-drawer-wrapper {
  padding: 20px;
}
</style>

<style>
.my-color-picker {
  z-index: 10001 !important;
}
</style>
